
/**
 * Module dependencies.
 */

import { availableFiltersKeys } from 'src/core/collections-config/filters';
import {
  hueVariation,
  hueVariationIcons
} from 'src/core/collections-config/hue-variations';

import { useFiltersList } from 'src/context/filters-list/context';
import { useTranslate } from 'src/core/utils/translator';
import FilterDisclosure from 'src/components/filters/filter-disclosure';
import FilterItem from 'src/components/filters/filter-item';
import FilterItemLabel from 'src/components/filters/filter-item-label';
import React, { ReactElement } from 'react';
import keys from 'lodash/keys';
import split from 'lodash/split';

/**
 * Filter name.
 */

const filterName = availableFiltersKeys.hueVariation;

/**
 * `HueVariationFilter` component.
 */

const HueVariationFilter = (): ReactElement => {
  const { translate } = useTranslate();
  const { filters } = useFiltersList();
  const hasFilter = keys(filters).includes(filterName);
  const selectedFilters = hasFilter ? split(filters[filterName], ',').map(variation => {
    return translate(`collections:hueVariation.${variation}`);
  }) : [];

  return (
    <FilterDisclosure
      name={filterName}
      selectedFilters={selectedFilters}
      title={translate('collections:labels.hueVariation')}
    >
      {Object.values(hueVariation).map((variation: string) => (
        <FilterItem
          key={variation}
          label={(
            <FilterItemLabel
              title={translate(`collections:hueVariation.${variation}`)}
              type={'icon'}
              value={hueVariationIcons[variation]}
            />
          )}
          name={filterName}
          value={variation}
        />
      ))}
    </FilterDisclosure>
  );
};

/**
 * Export `HueVariationFilter` component.
 */

export default HueVariationFilter;
